(function () {
  if (window.__lfvInit) return;
  window.__lfvInit = true;

  var overlay = null;
  var videoEl = null;

  function build() {
    if (overlay) return;
    overlay = document.createElement('div');
    overlay.className = 'lfv-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'lfv-overlay__close';
    close.setAttribute('aria-label', 'Close');
    close.innerHTML = '&#215;';

    videoEl = document.createElement('video');
    videoEl.className = 'lfv-overlay__video';
    videoEl.setAttribute('playsinline', '');
    videoEl.setAttribute('controls', '');
    videoEl.preload = 'auto';

    overlay.appendChild(close);
    overlay.appendChild(videoEl);
    document.body.appendChild(overlay);

    function closeFn() {
      overlay.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      try { videoEl.pause(); } catch (e) {}
      videoEl.removeAttribute('src');
      videoEl.load();
    }
    close.addEventListener('click', closeFn);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeFn(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeFn();
    });
  }

  function open(src, poster) {
    build();
    if (poster) { videoEl.poster = poster; } else { videoEl.removeAttribute('poster'); }
    videoEl.src = src;
    overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    var p = videoEl.play();
    if (p && p.catch) p.catch(function () {});
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var dismiss = e.target.closest('[data-lfv-dismiss]');
    if (dismiss) {
      e.preventDefault();
      e.stopPropagation();
      var bubble = dismiss.closest('[data-lfv-bubble]');
      if (bubble) bubble.style.display = 'none';
      return;
    }

    var btn = e.target.closest('[data-lfv-open]');
    if (!btn) return;
    e.preventDefault();
    var src = btn.getAttribute('data-lfv-src');
    if (!src) return;
    open(src, btn.getAttribute('data-lfv-poster'));
  });
})();
